import React, {} from 'react';
import './index.css'

function Footer() {
  return(
    <div className="footer">
    </div>
  )
}

export default Footer;
